
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M1.474.625h13.473c.466 0 .842.373.842.833v1.667H.632V1.458c0-.46.377-.833.842-.833zm14.316 6.25c-2.093 0-3.79-1.68-3.79-3.75M.632 6.875c2.092 0 3.79-1.68 3.79-3.75"}}),_c('path',{attrs:{"d":"M6.79 9.365a1.429 1.429 0 011.604-1.223A1.424 1.424 0 019.63 9.365l.62 8.952a1.26 1.26 0 001.245 1.058h3.031c.698 0 1.263-.56 1.263-1.25v-15H.632v15c0 .69.565 1.25 1.263 1.25h3.031a1.26 1.26 0 001.25-1.058l.615-8.952z"}})])])
          )
        }
      }
    